import { takeLatest, put, call, fork } from 'redux-saga/effects';
import ResetPasswordTypes from './ResetPassword.types';
import { resetPassword, resetFingerprint } from './ResetPassword.services';
import {
	resetPasswordSuccess,
	resetPasswordFailure,
	resetFingerprintFailure,
	resetFingerprintSuccess,
} from './ResetPassword.action';
import { encryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';

export function* fetchResetPasswordSaga(payload: any) {
	try {
		console.log('fetchResetPasswordSaga called with payload:', payload);
		const encryptedData = encryptData(payload.payload, ResetPasswordTypes.RESET_PASSWORD_KEY);
		// @ts-ignore
		const responseData = yield call(resetPassword as any, encryptedData);
		console.log('fetchResetPasswordSaga response:', responseData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(resetPasswordSuccess(responseData.data));
			} else {
				yield put(resetPasswordFailure(responseData.data));
			}
		}
	} catch (error: any) {
		console.error('fetchResetPasswordSaga error:', error);
		yield put(resetPasswordFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* fetchResetFingerprintSaga(payload: any) {
	try {
		console.log('fetchResetFingerprintSaga called with payload:', payload);
		const encryptedData = encryptData(
			payload.payload,
			ResetPasswordTypes.RESET_FINGERPRINT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(resetFingerprint as any, encryptedData);
		console.log('fetchResetFingerprintSaga response:', responseData);
		console.log('fetchResetFingerprintSaga response.data:', responseData?.data);
		
		if (responseData?.data?.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			// Handle different response structures
			const response = responseData?.data || responseData;
			const status = response?.status || response?.Status || response?.STATUS;
			console.log('fetchResetFingerprintSaga status:', status);
			
			if (status === 'success' || status === 'Success' || status === 'SUCCESS') {
				yield put(resetFingerprintSuccess(response));
			} else {
				// Treat as error if status is explicitly error, otherwise still dispatch success if we have a response
				if (status === 'error' || status === 'Error' || status === 'ERROR') {
					yield put(resetFingerprintFailure(response));
				} else {
					// If no clear status but we have a response, assume success
					console.warn('fetchResetFingerprintSaga: No clear status, assuming success');
					yield put(resetFingerprintSuccess(response || responseData?.data));
				}
			}
		}
	} catch (error: any) {
		console.error('fetchResetFingerprintSaga error:', error);
		yield put(resetFingerprintFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onResetPasswordStart(): Generator<any, void, any> {
	yield takeLatest(
		ResetPasswordTypes.RESET_PASSWORD_START as any,
		fetchResetPasswordSaga,
	);
}

export function* onResetFingerprintStart(): Generator<any, void, any> {
	yield takeLatest(
		ResetPasswordTypes.RESET_FINGERPRINT_START as any,
		fetchResetFingerprintSaga,
	);
}

export function* resetPasswordSaga(): Generator<any, void, any> {
	yield fork(onResetPasswordStart);
	yield fork(onResetFingerprintStart);
}
